import React, { useState, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import CameraIcon from '@mui/icons-material/PhotoCameraOutlined';
import { uploadToS3 } from '../../../helpers/uploadToS3';

const UploadButton = ({ class_name, id_name, dirName, img, onURL, defaultImage }) => {
    const fileInput = useRef();
    const [image, setImage] = useState(img);
    const [loading, setLoading] = useState(false);
    const getImage = () => {
        return img && img.length > 0 ? img : defaultImage;
    };

    const handleUpload = async () => {
        const file = fileInput.current.files[0];
        if (!file) return;

        setLoading(true);
        try {
            const { publicUrl, path } = await uploadToS3({ file, dirName });
            setImage(publicUrl);
            onURL(path);
        } catch (err) {
            console.error('Upload failed:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box className={class_name} sx={{ width: '140px', height: '140px', borderRadius: '15px', background: `url(${getImage()}) center center / cover no-repeat silver` }}>
            {loading && (
                <div style={{ width: '100%', height: '100%', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </div>
            )}
            <input accept="image/*" id={id_name} type="file" ref={fileInput} onChange={(e) => handleUpload()} style={{ display: 'none' }} />
            <label htmlFor={id_name} style={{ width: '100%', cursor: 'pointer' }}>
                <Box sx={{ background: 'transparent', height: '110px' }} />
                <Box
                    sx={{
                        width: '100%',
                        height: '30px',
                        backgroundColor: 'black',
                        borderRadius: '0 0 15px 15px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        'svg path': { fill: '#ffffff' }
                    }}
                >
                    <CameraIcon />
                </Box>
            </label>
        </Box>
    );
};

export default UploadButton;
